import HttpClient from "HttpClient";
import apiRoutes from "../../Routes/Routes.json";
    
export const InstrumentGetAll = async (payload: any) => {
  const response = await HttpClient().post(
    `/${apiRoutes.Oncology.OncologyBatchInstrument.GetInstruments}`,
    payload
  );
  return response;
};

export const InstrumentSave = async (payload: any) => {
  const response = await HttpClient().post(
    `/${apiRoutes.Oncology.OncologyBatchInstrument.SaveInstrument}`,
    payload
  );
  return response;
};

export const InstrumentToggleStatus = async (batchInstrumentId: number) => {
  const response = await HttpClient().patch(
    `/${apiRoutes.Oncology.OncologyBatchInstrument.ToggleInstrumentStatus}/${batchInstrumentId}`,
    null
  );
  return response;
};

export const GetBatchInstrumentLookup = async () => {
  const response = await HttpClient().get(
    `${apiRoutes.Oncology.OncologyBatchInstrument.GetBatchInstrumentLookup}`
    // `https://localhost:7121/api/OncologyBatchInstrument/GetBatchInstrumentLookup`,

  );
  return response;
};
